import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row, Tabs, Card, DatePicker } from "antd";
import axios from "axios";
import "./Pages.css";
import TituloLiquidarForm from '../components/TituloLiquidarForm';
import TituloFiltroForm from '../components/TituloFiltroForm';
import BalancoPrintModal from "../relatorios/BalancoPrintModal";
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import { maskDate } from "../utils/Masker";
import Colors from '../utils/Colors';
import RelBalancoFinanc from '../tutoriais/RelBalancoFinanc';

const dateFormat = 'DD/MM/YYYY'
const { RangePicker } = DatePicker;
const { Column } = Table;
const TabPane = Tabs.TabPane;

export default class extends Component {
  state = {
    listaRegistrosResultado: [],
    listaRegistrosEntradas: [],
    listaRegistrosSaidas: [],
    listaRegistrosReceber: [],
    listaRegistrosPagar: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    formVisivel: false,
    formFiltroVisivel: false,
    formLiqVisivel: false,

    vlrEntradas: 0,
    vlrSaidas: 0,
    vlrResultado: 0,
    vlrReceber: 0,
    vlrPagar: 0,
    vlrReceberVenc: 0,
    vlrPagarVenc: 0,
    vlrProvisao: 0,
    vlrProvisaoVenc: 0,

    activeKey: "resultado",

    registroParc: [],

    filtros: {
      tipoTela: 'BAL',
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      // buscaDataIni: moment().format('DD/MM/YYYY'),
      // buscaDataFim: moment().format('DD/MM/YYYY'),
      buscaControle: '',
      buscaNumero: '',
      buscaDescricao: '',
      buscaTipo: { key: 'X', },
      buscaSituacao: { key: 'X', },
      buscaPessoa: { key: '0' },
      buscaPlanoCta: { key: '0' },
      buscaCtaCorrente: { key: '0' },
      buscaTipoDoc: { key: '0' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    });
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }

  getListaRegistros = () => {
    this.setState({
      listaRegistrosResultado: [], listaRegistrosEntradas: [], listaRegistrosSaidas: [],
      listaRegistrosReceber: [], listaRegistrosPagar: [], carregando: true
    });
    const { pagina, limite, activeKey } = this.state;

    const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle,
      buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaTipoDoc,
      buscaDescricao } = this.state.filtros;


    if (activeKey === 'resultado') {

      this.getListaRegistrosResultado();

    } else {

      if ((buscaDataIni) && (buscaDataFim)) {

        let dataIni = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
          dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let dataFim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
          dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        let buscaTipoAux = '';
        let buscaSituacaoAux = '';
        if (activeKey === 'entradas') {
          buscaTipoAux = 'E';
          buscaSituacaoAux = 'P';
        } else if (activeKey === 'saidas') {
          buscaTipoAux = 'S';
          buscaSituacaoAux = 'P';
        } else if (activeKey === 'receber') {
          buscaTipoAux = 'E';
          buscaSituacaoAux = 'A';
        } else if (activeKey === 'pagar') {
          buscaTipoAux = 'S';
          buscaSituacaoAux = 'A';
        }

        axios
          .get('/titulos/listaBalancoFinanc', {
            params: {
              page: pagina,
              limite: limite,
              controle: buscaControle,
              numero: buscaNumero,
              descricao: buscaDescricao,
              tipo: buscaTipoAux,
              situacao: buscaSituacaoAux,
              pessoa: buscaPessoa.key,
              ctaFin: buscaPlanoCta.key,
              tipoDoc: buscaTipoDoc.key,
              ctaCorrente: buscaCtaCorrente.key,
              dataIni,
              dataFim,
            }
          })
          .then(response => {
            const { data, total, current_page, per_page } = response.data;

            if (activeKey === 'entradas') {
              this.setState({
                listaRegistrosEntradas: data,
                carregando: false,
                total: total,
                pagina: current_page,
                limite: Number(per_page),
              },
                this.getSomatorioResultado()
              );
            } else if (activeKey === 'saidas') {
              this.setState({
                listaRegistrosSaidas: data,
                carregando: false,
                total: total,
                pagina: current_page,
                limite: Number(per_page),
              },
                this.getSomatorioResultado()
              );
            } else if (activeKey === 'receber') {
              this.setState({
                listaRegistrosReceber: data,
                carregando: false,
                total: total,
                pagina: current_page,
                limite: Number(per_page),
              },
                this.getSomatorioResultado()
              );
            } else if (activeKey === 'pagar') {
              this.setState({
                listaRegistrosPagar: data,
                carregando: false,
                total: total,
                pagina: current_page,
                limite: Number(per_page),
              },
                this.getSomatorioResultado()
              );
            }

          })
          .catch(erro => {
            console.warn(erro);
            this.setState({
              carregando: false,
            });
          });
      } else {
        this.setState({
          listaRegistrosEntradas: [],
          listaRegistrosSaidas: [],
          listaRegistrosReceber: [],
          listaRegistrosPagar: [],
          carregando: false,
        });
      }
    }
  };

  getListaRegistrosResultado = () => {
    this.setState({ carregando: true });
    const { pagina, limite } = this.state;
    const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle,
      buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaTipoDoc,
      buscaDescricao } = this.state.filtros;

    if ((buscaDataIni) && (buscaDataFim)) {

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      axios
        .get('/titulos/listaBalancoFinancResultado', {
          params: {
            page: pagina,
            limite: limite,
            controle: buscaControle,
            numero: buscaNumero,
            descricao: buscaDescricao,
            pessoa: buscaPessoa.key,
            ctaFin: buscaPlanoCta.key,
            tipoDoc: buscaTipoDoc.key,
            ctaCorrente: buscaCtaCorrente.key,
            dataIni,
            dataFim,
          }
        })
        .then(response => {
          this.setState({
            listaRegistrosResultado: response.data,
            carregando: false,
          },
            this.getSomatorioResultado()
          );

        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    } else {
      this.setState({
        listaRegistrosResultado: [],
        carregando: false,
      });
    }
  };

  getSomatorioResultado = () => {
    this.setState({
      vlrEntradas: 0, vlrSaidas: 0, vlrResultado: 0,
      vlrReceber: 0, vlrPagar: 0, vlrReceberVenc: 0, vlrPagarVenc: 0,
      vlrProvisao: 0, vlrProvisaoVenc: 0,
    });
    const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle,
      buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaTipoDoc,
      buscaDescricao } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/titulos/somatorioBalancoFinancResultado', {
        params: {
          controle: buscaControle,
          numero: buscaNumero,
          descricao: buscaDescricao,
          pessoa: buscaPessoa.key,
          ctaFin: buscaPlanoCta.key,
          tipoDoc: buscaTipoDoc.key,
          ctaCorrente: buscaCtaCorrente.key,
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        this.setState({
          vlrEntradas: response.data.vlrEntradas,
          vlrSaidas: response.data.vlrSaidas,
          vlrResultado: parseFloat(response.data.vlrEntradas) - parseFloat(response.data.vlrSaidas),
          vlrReceber: response.data.vlrReceber,
          vlrPagar: response.data.vlrPagar,
          vlrReceberVenc: response.data.vlrReceberVenc,
          vlrPagarVenc: response.data.vlrPagarVenc,
          vlrProvisao: parseFloat(response.data.vlrReceber) - parseFloat(response.data.vlrPagar),
          vlrProvisaoVenc: parseFloat(response.data.vlrReceberVenc) - parseFloat(response.data.vlrPagarVenc),
        });
      })
      .catch(erro => {
        console.warn(erro);
      });
  };




  onLiquidarClick = () => {
    this.setState({
      formLiqVisivel: false,
    },
      this.getListaRegistros
    )
  };

  onCancelarLiqClick = () => {
    this.setState({
      formLiqVisivel: false
    })
  }

  onVisualizarClick = registro => {
    this.setState({ carregando: true });
    axios
      .get('/titulos/showParcela', {
        params: {
          idf: registro.tit_idf,
          parc: registro.tparc_parcela,
        }
      })
      .then(response => {
        const { data } = response;

        data.tparc_tipo_doc = {
          key: String(this.state.usuario.par_doc_padrao),
          label: this.state.usuario.td_descricao,
        }
        data.tparc_conta_corrente = {
          key: String(this.state.usuario.par_cta_corrente_padrao),
          label: this.state.usuario.cc_descricao,
        }

        data.pgto_data = moment().format('DD/MM/YYYY');
        data.tipoTela = 'LIQ';

        this.setState({
          formLiqVisivel: true,
          registroParc: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };




  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({
      [id]: value
    },
      this.getListaRegistros
    );
  };

  onChangePeriodo = event => {
    const { filtros } = this.state;
    if (event[0]) {
      filtros.buscaDataIni = moment(event[0]._d).format('DD/MM/YYYY');
      filtros.buscaDataFim = moment(event[1]._d).format('DD/MM/YYYY');
    } else {
      filtros.buscaDataIni = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY');
      filtros.buscaDataFim = moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY');
    }
    this.setState({
      filtros
    },
      this.getListaRegistros
    );
  };


  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaNumero: String(this.state.filtros.buscaNumero),
        buscaControle: String(this.state.filtros.buscaControle),
        buscaDescricao: String(this.state.filtros.buscaDescricao),
        buscaTipo: this.state.filtros.buscaTipo,
        buscaSituacao: this.state.filtros.buscaSituacao,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaPlanoCta: this.state.filtros.buscaPlanoCta,
        buscaCtaCorrente: this.state.filtros.buscaCtaCorrente,
        buscaTipoDoc: this.state.filtros.buscaTipoDoc,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros()
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };






  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderAcoes = (registro) => {
    return (
      <div>
        {getTemPermissao('BalancoFinancPage', 'editar') ? (
          <Tooltip title={registro.situacao_parcela === 'PAGO' ? 'Abrir' : 'Liquidar'}>
            <Button type="primary" size="small" onClick={() => this.onVisualizarClick(registro)} icon="check" style={{ backgroundColor: Colors.primaryLight, borderColor: Colors.primaryLight }} />
          </Tooltip>
        ) : null}
      </div>
    );
  };

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderValorCred = (tpp_valor, registro) => {
    if (registro.pc_tipo === 'E') {
      return (
        <span> {numeral(parseFloat(tpp_valor)).format('0,000.00')} </span>
      );
    } else {
      return (
        <span>-</span>
      );
    }
  };

  renderValorDeb = (tpp_valor, registro) => {
    if (registro.pc_tipo === 'S') {
      return (
        <span> {numeral(parseFloat(tpp_valor)).format('0,000.00')} </span>
      );
    } else {
      return (
        <span>-</span>
      );
    }
  };

  renderCtaFin = (pc_abreviatura, registro) => {
    return (
      <Tooltip title={registro.pc_descricao}>{pc_abreviatura}</Tooltip>
    );
  };

  renderParcela = (tparc_parcela, registro) => {
    return (
      <span> {tparc_parcela + ' / ' + registro.qtde_parcelas} </span>
    );
  };

  renderValorEnt = (vlr, registro) => {
    if (registro.pc_tipo === 'E') {
      return (
        <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
      );
    } else {
      return (
        <span>-</span>
      );
    }
  };

  renderValorSai = (vlr, registro) => {
    if (registro.pc_tipo === 'S') {
      return (
        <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
      );
    } else {
      return (
        <span>-</span>
      );
    }
  };

  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros
    )
  })

  onChangeTabs = (activeKey) => {
    this.setState({
      activeKey
    },
      this.getListaRegistros
    );
  }




  formatarMoeda = (vlr) => {
    const numero = parseFloat(vlr || 0);
    return `R$ ${numeral(numero).format('0,000.00')}`;
  };

  formatarPercentual = (vlr) => {
    const numero = parseFloat(vlr || 0);
    return `${numeral(numero).format('0,000.00')}%`;
  };


  renderCardResumo = ({
    titulo,
    valor,
    subtitulo,
    cor = Colors.primaryDark,
    badge = null,
  }) => {

    return (
      <Card
        bordered={false}
        bodyStyle={{
          padding: 18
        }}
        style={{
          borderRadius: 8,
          boxShadow: '0 1px 6px rgba(0,0,0,.08)',
          height: 115
        }}
      >

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >

          <div>

            <div
              style={{
                fontSize: 13,
                color: '#666',
                marginBottom: 8,
                fontWeight: 500
              }}
            >
              {titulo}
            </div>

            <div
              style={{
                fontSize: 24,
                fontWeight: 700,
                color: cor,
                lineHeight: '28px'
              }}
            >
              {valor}
            </div>

            <div
              style={{
                fontSize: 12,
                color: '#999',
                marginTop: 8
              }}
            >
              {subtitulo}
            </div>

          </div>

          {badge ? (
            <span
              style={{
                background: badge.cor,
                color: '#fff',
                padding: '3px 10px',
                borderRadius: 20,
                fontSize: 11,
                height: 24
              }}
            >
              {badge.texto}
            </span>
          ) : null}

        </div>

      </Card>
    );
  };








  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistrosEntradas, listaRegistrosSaidas, listaRegistrosReceber, listaRegistrosPagar,
      carregando, registroParc, formFiltroVisivel, formLiqVisivel, listaRegistrosResultado,
      filtros, total, pagina, limite,
    } = this.state;

    const { buscaDataIni, buscaDataFim } = this.state.filtros;

    // console.log('STATE: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Balanço Financeiro</span>
          <Tooltip title="Ajuda">
            <Button
              type="primary"
              onClick={() => this.setState({ modalOpen: true })}
              icon="question"
              className="botao-ajuda"
            ></Button>
          </Tooltip>
        </div>
        <div className="divider-page" />

        <Row style={{ marginBottom: 10 }}>
          <div className="pageFiltro" style={{ height: 20 }}>

            <Col xs={6} style={{ marginRight: 10 }}>
              <span>Período</span>
              <RangePicker
                style={{ width: "100%" }}
                masker={maskDate}
                value={[moment(buscaDataIni, dateFormat), moment(buscaDataFim, dateFormat)]}
                format={dateFormat}
                allowClear={false}
                onChange={this.onChangePeriodo}
              />
            </Col>
            <Col xs={6} style={{ marginTop: 20 }} >
              <Col xs={2} style={{ width: 110 }}>
                <Button
                  type="primary"
                  onClick={this.onAbrirFiltroClick}
                  className="botao-primary"
                  style={{ marginRight: 15 }}
                >
                  Filtrar
                </Button>
              </Col>

              <Col xs={2} style={{ width: 110 }}>
                <BalancoPrintModal
                  filtros={filtros}
                  tela={this.state.activeKey}
                  periodo={this.state.filtros.buscaDataIni + ' a ' + this.state.filtros.buscaDataFim}
                  vlrEntradas={this.state.vlrEntradas}
                  vlrSaidas={this.state.vlrSaidas}
                  vlrResultado={this.state.vlrResultado}
                  vlrReceber={this.state.vlrReceber}
                  vlrPagar={this.state.vlrPagar}
                  vlrReceberVenc={this.state.vlrReceberVenc}
                  vlrPagarVenc={this.state.vlrPagarVenc}
                  vlrProvisao={this.state.vlrProvisao}
                  vlrProvisaoVenc={this.state.vlrProvisaoVenc}
                />
              </Col>
            </Col>


            <TituloFiltroForm
              visivel={formFiltroVisivel}
              onFiltrarClick={this.onFiltrarClick}
              onCancelarFiltroClick={this.onCancelarFiltroClick}
              filtros={filtros}
            />

            <TituloLiquidarForm
              visivel={formLiqVisivel}
              onLiquidarClick={this.onLiquidarClick}
              onCancelarLiqClick={this.onCancelarLiqClick}
              registroParc={registroParc}
            />

            <RelBalancoFinanc
              isOpen={this.state.modalOpen}
              onClose={() => this.setState({ modalOpen: false })}
            />
          </div>
        </Row>

        <Row>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Resultado Financeiro" key="resultado">
              <div style={{ paddingTop: 0, height: 400 }}>


                <Col xs={24} style={{}}>

                  <Col xs={24} style={{ background: Colors.background, padding: 10, marginBottom: 20 }}>
                    <Row gutter={16} style={{ marginBottom: 16 }}>
                      <Col span={6}>
                        {this.renderCardResumo({
                          titulo: 'Entradas',
                          valor: this.formatarMoeda(this.state.vlrEntradas),
                          subtitulo: 'Recebido no período',
                          cor: '#16a34a'
                        })}
                      </Col>

                      <Col span={6}>
                        {this.renderCardResumo({
                          titulo: 'Saídas',
                          valor: this.formatarMoeda(this.state.vlrSaidas),
                          subtitulo: 'Pago no período',
                          cor: '#dc2626'
                        })}
                      </Col>

                      <Col span={6}>
                        {this.renderCardResumo({
                          titulo: 'Resultado',
                          valor: this.formatarMoeda(this.state.vlrResultado),
                          subtitulo: 'Entradas - Saídas',
                          cor: this.state.vlrResultado >= 0
                            ? '#2563eb'
                            : '#dc2626'
                        })}
                      </Col>

                      <Col span={6}>
                        {this.renderCardResumo({
                          titulo: 'Margem Financeira',
                          valor: this.formatarPercentual(
                            this.state.vlrEntradas > 0
                              ? (this.state.vlrResultado / this.state.vlrEntradas) * 100
                              : 0
                          ),
                          subtitulo: 'Resultado / Entradas',
                          cor: '#16a34a'
                        })}
                      </Col>
                    </Row>
                  </Col>


                  <Col xs={24} style={{ background: Colors.background, padding: 10 }}>
                    <Row gutter={16} style={{ marginBottom: 16 }}>
                      <Col span={6}>
                        {this.renderCardResumo({
                          titulo: 'Contas a Receber',
                          valor: this.formatarMoeda(this.state.vlrReceber),
                          subtitulo: 'Valores futuros',
                          cor: '#0891b2'
                        })}
                      </Col>

                      <Col span={6}>
                        {this.renderCardResumo({
                          titulo: 'Contas a Pagar',
                          valor: this.formatarMoeda(this.state.vlrPagar),
                          subtitulo: 'Compromissos futuros',
                          cor: '#ea580c'
                        })}
                      </Col>

                      <Col span={6}>
                        {this.renderCardResumo({
                          titulo: 'Saldo Projetado',
                          valor: this.formatarMoeda(this.state.vlrProvisao),
                          subtitulo: 'Receber - Pagar',
                          cor:
                            this.state.vlrProvisao >= 0
                              ? '#16a34a'
                              : '#dc2626'
                        })}
                      </Col>

                      <Col span={6}>
                        {this.renderCardResumo({
                          titulo: 'Saúde Financeira',
                          valor:
                            this.state.vlrPagar > 0
                              ? numeral(this.state.vlrReceber / this.state.vlrPagar).format('0.00')
                              : '0.00',
                          subtitulo: 'Receber / Pagar',
                          cor: '#0c6681',
                          badge: {
                            texto:
                              this.state.vlrReceber > this.state.vlrPagar
                                ? 'Boa'
                                : 'Crítica',
                            cor:
                              this.state.vlrReceber > this.state.vlrPagar
                                ? '#16a34a'
                                : '#dc2626'
                          }
                        })}
                      </Col>
                    </Row>
                  </Col>

                  <Col xs={24} style={{ background: Colors.background, padding: 10 }}>
                    <Row gutter={16} style={{ marginBottom: 20 }}>
                      <Col span={8}>
                        {this.renderCardResumo({
                          titulo: 'Receber Vencido',
                          valor: this.formatarMoeda(this.state.vlrReceberVenc),
                          subtitulo: 'Valores em atraso',
                          cor: '#dc2626'
                        })}
                      </Col>

                      <Col span={8}>
                        {this.renderCardResumo({
                          titulo: 'Pagar Vencido',
                          valor: this.formatarMoeda(this.state.vlrPagarVenc),
                          subtitulo: 'Compromissos atrasados',
                          cor: '#ea580c'
                        })}
                      </Col>

                      <Col span={8}>
                        {this.renderCardResumo({
                          titulo: 'Saldo Vencido',
                          valor: this.formatarMoeda(this.state.vlrProvisaoVenc),
                          subtitulo: 'Receber vencido - Pagar vencido',
                          cor:
                            this.state.vlrProvisaoVenc >= 0
                              ? '#16a34a'
                              : '#dc2626'
                        })}
                      </Col>
                    </Row>
                  </Col>


                </Col>


                <Col xs={24} style={{ background: Colors.background, padding: 10, height: 405 }}>
                  <Table
                    pagination={false}
                    loading={{
                      spinning: carregando,
                      tip: 'Carregando. Aguarde...',
                      size: "large"
                    }}
                    dataSource={listaRegistrosResultado}
                    // height={800}
                    rowKey={(registro => registro.pc_descricao)}
                    style={{ background: "white", height: 385 }}
                    bordered
                  >
                    <Column
                      key="pc_descricao"
                      dataIndex="pc_descricao"
                      title="Conta Financeira"
                      width={50}
                      align="left"
                      className="listaCadastro"
                    />
                    <Column
                      key="vlr1"
                      dataIndex="vlr"
                      title="Entradas"
                      render={this.renderValorEnt}
                      width={20}
                      align="right"
                      className="listaCadastro"
                    />
                    <Column
                      key="vlr2"
                      dataIndex="vlr"
                      title="Saídas"
                      render={this.renderValorSai}
                      width={20}
                      align="right"
                      className="listaCadastro"
                    />
                  </Table>
                </Col>
              </div>
            </TabPane>

            <TabPane tab="Entradas" key="entradas">
              <div style={{ paddingTop: 0 }}>
                <Table
                  pagination={{
                    total: total,
                    pageSize: limite,
                    current: pagina,
                    pageSizeOptions: ['10', '20', '30', '40'],
                    showSizeChanger: true,
                  }}
                  onChange={this.onTabelaChange}
                  loading={{
                    spinning: carregando,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaRegistrosEntradas}
                  rowKey={(registro => registro.tit_idf + '_' + registro.tparc_parcela)}
                >
                  <Column
                    key="pgto_data"
                    dataIndex="pgto_data"
                    title="Data Pagto"
                    render={this.renderData}
                    width={100}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="pc_abreviatura"
                    dataIndex="pc_abreviatura"
                    title="Conta"
                    width={60}
                    align="left"
                    className="listaCadastro"
                    render={this.renderCtaFin}
                  />
                  <Column
                    key="pgto_vlr_pago"
                    dataIndex="pgto_vlr_pago"
                    title="Valor Pagto"
                    render={this.renderValor}
                    width={90}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="tparc_parcela"
                    dataIndex="tparc_parcela"
                    title="Parcela"
                    width={80}
                    align="center"
                    className="listaCadastro"
                    render={this.renderParcela}
                  />
                  <Column
                    key="td_descricao"
                    dataIndex="td_descricao"
                    title="Tipo Docto"
                    width={120}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_controle"
                    dataIndex="tit_controle"
                    title="Controle"
                    width={70}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_numero"
                    dataIndex="tit_numero"
                    title="Número"
                    width={70}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="pes_nome"
                    dataIndex="pes_nome"
                    title="Nome"
                    width={200}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_descricao"
                    dataIndex="tit_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoes}
                    width={40}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
                {listaRegistrosPagar && listaRegistrosEntradas.length > 0 ? (
                  <Row style={{ marginTop: -50, width: 150 }}>
                    <Col xs={24} style={{ background: Colors.background, padding: 5 }}>
                      <Col xs={24} style={{ textAlign: "center", background: "white" }} >
                        <Row><span style={{ fontWeight: "bold" }}>Total</span></Row>
                        <Row><span>R$ {this.renderValor(this.state.vlrEntradas)}</span></Row>
                      </Col>
                    </Col>
                  </Row>
                ) : null}
              </div>
            </TabPane>

            <TabPane tab="Saídas" key="saidas">
              <div style={{ paddingTop: 0 }}>
                <Table
                  pagination={{
                    total: total,
                    pageSize: limite,
                    current: pagina,
                    pageSizeOptions: ['10', '20', '30', '40'],
                    showSizeChanger: true,
                  }}
                  onChange={this.onTabelaChange}
                  loading={{
                    spinning: carregando,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaRegistrosSaidas}
                  rowKey={(registro => registro.tit_idf + '_' + registro.tparc_parcela)}
                >
                  <Column
                    key="pgto_data"
                    dataIndex="pgto_data"
                    title="Data Pagto"
                    render={this.renderData}
                    width={100}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="pc_abreviatura"
                    dataIndex="pc_abreviatura"
                    title="Conta"
                    width={60}
                    align="left"
                    className="listaCadastro"
                    render={this.renderCtaFin}
                  />
                  <Column
                    key="pgto_vlr_pago"
                    dataIndex="pgto_vlr_pago"
                    title="Valor Pagto"
                    render={this.renderValor}
                    width={90}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="tparc_parcela"
                    dataIndex="tparc_parcela"
                    title="Parcela"
                    width={80}
                    align="center"
                    className="listaCadastro"
                    render={this.renderParcela}
                  />
                  <Column
                    key="td_descricao"
                    dataIndex="td_descricao"
                    title="Tipo Docto"
                    width={120}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_controle"
                    dataIndex="tit_controle"
                    title="Controle"
                    width={70}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_numero"
                    dataIndex="tit_numero"
                    title="Número"
                    width={70}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="pes_nome"
                    dataIndex="pes_nome"
                    title="Nome"
                    width={200}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_descricao"
                    dataIndex="tit_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoes}
                    width={40}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
                {listaRegistrosPagar && listaRegistrosSaidas.length > 0 ? (
                  <Row style={{ marginTop: -50, width: 150 }}>
                    <Col xs={24} style={{ background: Colors.background, padding: 5 }}>
                      <Col xs={24} style={{ textAlign: "center", background: "white" }} >
                        <Row><span style={{ fontWeight: "bold" }}>Total</span></Row>
                        <Row><span>R$ {this.renderValor(this.state.vlrSaidas)}</span></Row>
                      </Col>
                    </Col>
                  </Row>
                ) : null}
              </div>
            </TabPane>

            <TabPane tab="Contas à Receber" key="receber">
              <div style={{ paddingTop: 0 }}>
                <Table
                  pagination={{
                    total: total,
                    pageSize: limite,
                    current: pagina,
                    pageSizeOptions: ['10', '20', '30', '40'],
                    showSizeChanger: true,
                  }}
                  onChange={this.onTabelaChange}
                  loading={{
                    spinning: carregando,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaRegistrosReceber}
                  rowKey={(registro => registro.tit_idf + '_' + registro.tparc_parcela)}
                >
                  <Column
                    key="tparc_data_parcela"
                    dataIndex="tparc_data_parcela"
                    title="Data Venc"
                    render={this.renderData}
                    width={120}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="pc_abreviatura"
                    dataIndex="pc_abreviatura"
                    title="Conta"
                    width={70}
                    align="left"
                    className="listaCadastro"
                    render={this.renderCtaFin}
                  />
                  <Column
                    key="tparc_valor"
                    dataIndex="tparc_valor"
                    title="Vlr Parcela"
                    render={this.renderValor}
                    width={100}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="pgto_vlr_pago"
                    dataIndex="pgto_vlr_pago"
                    title="Vlr Pago"
                    render={this.renderValor}
                    width={100}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="pgto_vlr_restante"
                    dataIndex="pgto_vlr_restante"
                    title="Vlr Restante"
                    render={this.renderValor}
                    width={110}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="tparc_parcela"
                    dataIndex="tparc_parcela"
                    title="Parcela"
                    width={80}
                    align="center"
                    className="listaCadastro"
                    render={this.renderParcela}
                  />
                  <Column
                    key="td_descricao"
                    dataIndex="td_descricao"
                    title="Tipo Docto"
                    width={120}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_controle"
                    dataIndex="tit_controle"
                    title="Controle"
                    width={80}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_numero"
                    dataIndex="tit_numero"
                    title="Número"
                    width={80}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="pes_nome"
                    dataIndex="pes_nome"
                    title="Nome"
                    width={200}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_descricao"
                    dataIndex="tit_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoes}
                    width={40}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
                {listaRegistrosPagar && listaRegistrosReceber.length > 0 ? (
                  <Row style={{ marginTop: -50, width: 300 }}>
                    <Col xs={12} style={{ background: Colors.background, padding: 5 }}>
                      <Col xs={24} style={{ textAlign: "center", background: "white" }} >
                        <Row><span style={{ fontWeight: "bold" }}>Total</span></Row>
                        <Row><span>R$ {this.renderValor(this.state.vlrReceber)}</span></Row>
                      </Col>
                    </Col>
                    <Col xs={12} style={{ background: Colors.background, padding: 5 }}>
                      <Col xs={24} style={{ textAlign: "center", background: "white" }} >
                        <Row><span style={{ fontWeight: "bold" }}>Vencido</span></Row>
                        <Row><span>R$ {this.renderValor(this.state.vlrReceberVenc)}</span></Row>
                      </Col>
                    </Col>
                  </Row>
                ) : null}
              </div>
            </TabPane>

            <TabPane tab="Contas à Pagar" key="pagar">
              <div style={{ paddingTop: 0 }}>
                <Table
                  pagination={{
                    total: total,
                    pageSize: limite,
                    current: pagina,
                    pageSizeOptions: ['10', '20', '30', '40'],
                    showSizeChanger: true,
                  }}
                  onChange={this.onTabelaChange}
                  loading={{
                    spinning: carregando,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaRegistrosPagar}
                  rowKey={(registro => registro.tit_idf + '_' + registro.tparc_parcela)}
                >
                  <Column
                    key="tparc_data_parcela"
                    dataIndex="tparc_data_parcela"
                    title="Data Venc"
                    render={this.renderData}
                    width={120}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="pc_abreviatura"
                    dataIndex="pc_abreviatura"
                    title="Conta"
                    width={70}
                    align="left"
                    className="listaCadastro"
                    render={this.renderCtaFin}
                  />
                  <Column
                    key="tparc_valor"
                    dataIndex="tparc_valor"
                    title="Vlr Parcela"
                    render={this.renderValor}
                    width={100}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="pgto_vlr_pago"
                    dataIndex="pgto_vlr_pago"
                    title="Vlr Pago"
                    render={this.renderValor}
                    width={100}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="pgto_vlr_restante"
                    dataIndex="pgto_vlr_restante"
                    title="Vlr Restante"
                    render={this.renderValor}
                    width={110}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="tparc_parcela"
                    dataIndex="tparc_parcela"
                    title="Parcela"
                    width={80}
                    align="center"
                    className="listaCadastro"
                    render={this.renderParcela}
                  />
                  <Column
                    key="td_descricao"
                    dataIndex="td_descricao"
                    title="Tipo Docto"
                    width={120}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_controle"
                    dataIndex="tit_controle"
                    title="Controle"
                    width={80}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_numero"
                    dataIndex="tit_numero"
                    title="Número"
                    width={80}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="pes_nome"
                    dataIndex="pes_nome"
                    title="Nome"
                    width={200}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tit_descricao"
                    dataIndex="tit_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoes}
                    width={40}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
                {listaRegistrosPagar && listaRegistrosPagar.length > 0 ? (
                  <Row style={{ marginTop: -50, width: 300 }}>
                    <Col xs={12} style={{ background: Colors.background, padding: 5 }}>
                      <Col xs={24} style={{ textAlign: "center", background: "white" }} >
                        <Row><span style={{ fontWeight: "bold" }}>Total</span></Row>
                        <Row><span>R$ {this.renderValor(this.state.vlrPagar)}</span></Row>
                      </Col>
                    </Col>
                    <Col xs={12} style={{ background: Colors.background, padding: 5 }}>
                      <Col xs={24} style={{ textAlign: "center", background: "white" }} >
                        <Row><span style={{ fontWeight: "bold" }}>Vencido</span></Row>
                        <Row><span>R$ {this.renderValor(this.state.vlrPagarVenc)}</span></Row>
                      </Col>
                    </Col>
                  </Row>
                ) : null}
              </div>
            </TabPane>

          </Tabs>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/BalancoFinancPage.js